<script setup lang="ts">
    import { API_CONFIG, BACKEND_URL } from '@/services/apiConfig';
    import debounce from 'lodash.debounce';
    import { onMounted, ref } from 'vue';
    import { useRoute } from 'vue-router';

    const route = useRoute();
    const itemsList = ref([] as any[]);
    const query = ref("");

    onMounted(() => {
        const data: any = route.meta.startup_infos;
        itemsList.value = data;
        console.log(itemsList.value);
    });

    const search = debounce(async () => {
        const params = new URLSearchParams({
            q: query.value
        });
        const response = await fetch(`${API_CONFIG.baseURL}/tutoriels?${params.toString()}`, {
            method: 'GET',
            headers: API_CONFIG.headers
        });
        const responseData = await response.json();
        itemsList.value = responseData;
    }, 300);
</script>

<template>
    <div class="page-space"></div>
    <section class="container-lil">

        <!--Search in view Component-->
        <div class="search-view-input-set">
            <input type="text" class="search-view-input" placeholder="Faire une recherche..." v-model="query" @input="search" />
            <button class="btn-ultra white tips"><!-- loading sm tips color2 light white white2 success info warning danger-->
                <div class="btn-show">
                    <img src="/public/icons/icon-go.svg" class="btn-icon" alt="" />
                </div>
                <div class="btn-loading">
                    <div class="loader-dots"></div>
                </div>
            </button>
        </div>
        <!--End Search in view Component-->
        <div class="h-30"></div>

        <!--Catégorie-->
        <template v-for="categorie in itemsList" :key="'categorie_' + categorie.id">
            <div class="mb-10">
                <h1 class="secondary-font text-center my-2">{{ categorie.libelle }}</h1>

                <div class="grid-web3 mt-6">
                    <!--Tutorial component-->
                    <template v-for="aide in categorie.aides" :key="'item_' + aide.id">
                        <router-link :to="'/tutoriels/' + aide.slug">
                            <div class="card px-2 py-2">
                                <img :src="BACKEND_URL + '/assets/aide/1000/' + aide.fichier_photo" width="100%" class="mb-5" alt="" v-if="aide.fichier_photo" />
                                <h5 class="font-semibold text-black mt-3 mb-4 px-4">{{ aide.libelle }}</h5>
                            </div>
                        </router-link>
                    </template>
                    <!--End Tutorial component-->
                </div>
            </div>
        </template>
        <!---->

        <div class="clear-both h-40"></div>
    </section>
</template>
